import content from "@/content/service.json";

import { Scissors, Image as ImageIcon, Film } from "lucide-react";

interface Data {
  section_title: string;
  section_subtitle: string;
  items: {
    title: string;
    description: string;
  }[];
}

const data: Data = content;

const Service = () => {
  return (
    <section id="Serviços" className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-display text-foreground text-4xl tracking-wide sm:text-5xl">
            {data.section_title}
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl">
            {data.section_subtitle}
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {data.items.map((item, index) => (
            <div
              key={index}
              className="group border-border bg-card hover:border-primary/50 hover:bg-card/80 rounded-2xl border p-6 transition-all sm:p-8"
            >
              <div className="bg-secondary text-primary group-hover:bg-primary group-hover:text-primary-foreground mb-4 inline-flex rounded-xl p-3 transition-colors">
                {<ImageIcon />}
              </div>
              <h3 className="text-foreground text-xl font-semibold">
                {item.title}
              </h3>
              <p className="text-muted-foreground mt-3 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Service;
